export function LoadingState({ label = 'Loading your workspace...', className = '' }) {
  return (
    <div className={`loading-state ${className}`.trim()} role="status">
      <span className="spinner" aria-hidden="true" />
      <span>{label}</span>
    </div>
  );
}
